import React, { useEffect, useState } from "react";
import { loadProfile, getCachedProfile, setCachedProfile } from "../../../utils/Network";
import { getCurrentLanguage, getDefaultValue, logout } from "../../../utils";
import TalentPanel from "../../TalentPanel";
import { useStateValue } from "../../../StateProvider";
import DashboardHeaderProfileWidget from "../../../components/widgets/DashboardHeaderProfileWidget";
import DashboardAside from "./DashboardAside";
import PageHeaderLight from "../../../components/shared/PageHeaderLight";
import ProfileInformationLinear from "../../../components/shared/ProfileInformationLinear";
import "../../Dashboard.css";

//loadProfile();

export default function Artist() {
  const [profile, setProfile] = useState(() => getCachedProfile());
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(false);

  const [current_language, setCurrentLanguage] = useState(null);

  useEffect(() => {
    setLoading(true);


    setCurrentLanguage(getCurrentLanguage());
    loadProfile().then((profile) => {
      setProfile(profile);
      setLoading(false);
      if (profile) {
        setRole(profile.role);
        if (profile.role === "referee") {
          window.location.href = "/referee/dashboard";
        }

      } else {
        logout();
        window.location.href = "signin";
      }
    });
  }, []);

  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    var translate = translations.find(x => x.key == str);

    if (translate) return getDefaultValue(translate);
    else return "#" + str;
  };

  return (
    <div className="participant-dashboard">
      <div id="main" role="main" className="main page-background">
        <PageHeaderLight />

        <div className="container participant-dashboard__container pt-3 pb-5">
          <div className="row pt-2 align-items-start participant-dashboard__row">
            <div className="col-lg-9 participant-dashboard__main">
              <header className="participant-dashboard__header">
                <div className="participant-dashboard__header-inner">
                  <DashboardHeaderProfileWidget
                    profile={profile}
                    onProfileUpdated={(p) => {
                      setProfile(p);
                      setCachedProfile(p);
                    }}
                  />
                </div>
              </header>
              <div className="participant-dashboard__header-copy lan-text-right">
                <p className="participant-dashboard__subtitle mb-0">
                  {translate("Welcome to My Talents")}
                </p>
              </div>
              {role === "participant" && <TalentPanel />}
            </div>
            {/* <ProfileInformationLinear className="participant-dashboard__mobile-profile" /> */}
            <DashboardAside />
          </div>
        </div>
      </div>
    </div>
  );
}
